import React from 'react';
import GearItemCard from './GearItemCard';
import './PlayerAccordionTab.css';

function UnheldAccordionTab({
  gear,
  isExpanded,
  onTabClick,
  canModifyGear,
  teamPlayers,
  onEquip,
  teamGear,
  onTransferClick,
  isInTransferMode,
  tabState,
  transferGearId,
  swappableGearIds,
  onSwapClick
}) {
  // Determine tab class based on transfer state
  let tabStateClass = '';
  if (tabState === 'source') {
    tabStateClass = 'transfer-source';
  } else if (tabState === 'valid') {
    tabStateClass = 'transfer-valid';
  } else if (tabState === 'invalid') {
    tabStateClass = 'transfer-invalid';
  }

  return (
    <div className="accordion-tab">
      {/* Tab Header - Always Visible */}
      <div
        className={`tab-header ${isExpanded ? 'expanded' : 'collapsed'} ${tabStateClass}`}
        onClick={onTabClick}
      >
        <div className="tab-label">
          <span className="player-name">UNHELD</span>
        </div>
      </div>
      
      {/* Tab Content - Only visible when expanded */}
      {isExpanded && (
        <div className={`tab-content ${isInTransferMode ? 'transfer-mode' : ''}`}>
          {gear.length === 0 ? (
            <div className="no-gear-message">
              All gear is equipped
            </div>
          ) : (
            gear.map((item, index) => (
              <GearItemCard
                key={item.id}
                gear={item}
                gearNumber={index + 1}
                canModifyGear={canModifyGear}
                onEquip={onEquip}
                teamPlayers={teamPlayers}
                teamGear={teamGear}
                onTransferClick={onTransferClick}
                isInTransferMode={isInTransferMode}
                isTransferSource={transferGearId === item.id}
                isSwappable={swappableGearIds?.includes(item.id)}
                onSwapClick={onSwapClick}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default UnheldAccordionTab;